<section>
    <div class="options-step">
        <xm-plan-switch-promotions 
            *ngIf="isDiscountPromotion && !isIcopPlanSwitch"
            [isBogoPromoLossForUnl]="showBogoPromoLossForUnlLines"
            [promotionType]="promotionType"
            [promotionContent]="promoContent"
            [BYOPromoContent]="promoBYOContent"
            [UNLPromoContent]="promoUNLContent"
            [extendedPromoContent]="extendedPromoContent"
            [tradeInDDAPromoContent]="tradeInDDAPromoContent">
        </xm-plan-switch-promotions>
        <xm-icop-plan-switch-promotions *ngIf="isIcopPlanSwitch && showIcopPromotions"></xm-icop-plan-switch-promotions>
        <xm-switch-banner *ngIf="showSegmentUpgradeBanner && segmentSwitchBanner" [imageOptions]="segmentSwitchIcon"
            [header]="segmentSwitchBanner?.header" [description]="segmentSwitchBanner?.body" [cta]="segmentSwitchBanner?.cta">
        </xm-switch-banner>
        <div class="header">{{ pageData.header }}</div>
        <div class="data-plan desktop">
            <ul [ngClass]="{'selected': plan.isSelected, 'active': plan.planData.isEligible || plan.planData.isIneligibleInUse || plan.planData.requiresUpgrade, 'disable': plan.planData.isIneligibleOverage || plan.planData.isIneligibleBucket || plan.planData.isIneligibleChangePending}"
            *ngFor="let plan of availablePlanOptions">
                <li (click)="changePlanOption(plan)">
                    <button class="icon-border">
                        <div class="custom-icon data-{{getDataSize(plan)}}-units">
                            <span class="icon-content">
                                <span class="icon-text">{{ getDataSize(plan) }}</span>
                                <span class="icon-unit">{{ pageData.dataUnit }}</span>
                            </span>
                            <span class="icon-subhead"
                                *ngIf="!(plan.planData.isIneligibleInUse || plan.planData.inUseOnAccount)">${{ getDataPrice(plan) }}/{{ plan.cmsPlanData.priceUnit }}</span>
                            <div class="ineligible-inuse" *ngIf="plan.planData.isIneligibleInUse || plan.planData.inUseOnAccount" role="status" [attr.aria-label]="'By the Gig is ' + pageData.inUseSubheader">
                                <xm-media-image size="auto" class="checkmark-icon" [imageOptions]="checkmarkIcon">
                                </xm-media-image>
                                <span class="icon-subhead">{{ pageData.inUseSubheader }}</span>
                            </div>
                        </div>
                    </button>
                </li>
            </ul>
        </div>
        <xm-carousel class="mobile" [upperSettings]="carouselSettings" (activeSlideIndex)="changePlan($event)"
            [overrideButtonsAriaLabel]="overrideButtonsAriaLabel" [slideData]="availablePlanOptions"
            [slideIndex]="currentSlideIndex">
            <div class="selected swiper-slide" *ngFor="let plan of availablePlanOptions" [ngClass]="{'active': plan.planData.isEligible || plan.planData.isIneligibleInUse || plan.planData.requiresUpgrade, 'disable': plan.planData.isIneligibleOverage || plan.planData.isIneligibleBucket || plan.planData.isIneligibleChangePending}" upper>
                <button class="icon-border">
                    <div aria-hidden="true" class="custom-icon data-{{getDataSize(plan)}}-units">
                        <span class="icon-content">
                            <span class="icon-text">{{ getDataSize(plan) }}</span>
                            <span class="icon-unit">{{ pageData.dataUnit }}</span>
                        </span>
                        <span class="icon-subhead"
                            *ngIf="!(plan.planData.isIneligibleInUse || plan.planData.inUseOnAccount)">${{ getDataPrice(plan) }}/{{ plan.cmsPlanData.priceUnit }}</span>
                        <div class="ineligible-inuse" *ngIf="plan.planData.isIneligibleInUse || plan.planData.inUseOnAccount" role="status" [attr.aria-label]="' By the Gig ' + ' is ' + pageData.inUseSubheader">
                            <xm-media-image aria-hidden="true" size="height" class="checkmark-icon"
                                [imageOptions]="checkmarkIcon"></xm-media-image>
                            <span class="icon-subhead">{{ pageData.inUseSubheader }}</span>
                        </div>
                    </div>
                </button>
            </div>
        </xm-carousel>

        <p *ngIf="optionStepDescription" class="description">{{ optionStepDescription }}</p>

        <div class="buttons">
            <button class="xm-btn-link-light cancel" (click)="onCancel()">Cancel</button>
            <button class="xm-btn-primary-dark" [disabled]="!selectedPlan.planData.isEligible && !selectedPlan.planData.requiresUpgrade" (click)="navToReview()">
                {{ pageData.switchNowBtn }}</button>
        </div>
    </div>
</section>
